import { useQuery } from 'hooks/useCustomQuery';
import getCountry from 'API/Country/getCountry';

// The API returns a [''] sentinel for an empty codes array rather than [].
const normalizeCodes = (codes) => (!codes || codes[0] === '' ? [] : codes);

const useGetCountry = (countryId, enabled = true) => {
    return useQuery({
        queryKey: ['Country', countryId],
        queryFn: async () => {
            const response = await getCountry(countryId);
            const data = response.data;
            return {
                ...data,
                nationalCodes: normalizeCodes(data.nationalCodes),
                multiNationalCodes: normalizeCodes(data.multiNationalCodes),
            };
        },
        enabled: enabled && !!countryId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetCountry;
